// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientActionsButton-module__button___ExKZl {
  padding: 5px 10px;
  margin-left: -14px;
  gap: 4px !important;
  justify-content: flex-start !important;
}
.PatientActionsButton-module__button___ExKZl > img {
  width: 22px;
  height: 22px;
}
.PatientActionsButton-module__button___ExKZl > span {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/PatientDetailsNavigation/items/PatientActionsButton/PatientActionsButton.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EACE,0BAAA;AAAJ","sourcesContent":[".button {\n  padding: 5px 10px;\n  margin-left: -14px;\n  gap: 4px !important;\n  justify-content: flex-start !important;\n\n  & > img {\n    width: 22px;\n    height: 22px;\n  }\n\n  & > span {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `PatientActionsButton-module__button___ExKZl`
};
module.exports = ___CSS_LOADER_EXPORT___;
